module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "tc-box",
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_c('div', {
    staticClass: "tc-box-model",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "tc-box-model-top"
  }, [_c('div', {
    staticClass: "tc-box-model-top-div"
  }), _vm._v(" "), _c('div', {
    staticClass: "tc-box-model-top-title"
  }, [_vm._v(_vm._s(_vm.$t('all.tishi')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/image/wode_jiazu@2x.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  })]), _vm._v(" "), (_vm.data == 1) ? _c('div', {
    staticClass: "tc-box-model-center"
  }, [_vm._v(_vm._s(_vm.$t('all.quedingtuichudengluma')))]) : _vm._e(), _vm._v(" "), (_vm.data == 1) ? _c('div', {
    staticClass: "tc-box-model-bottom",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v(_vm._s(_vm.$t('all.queding')))]) : _vm._e(), _vm._v(" "), (_vm.data == 0) ? _c('div', {
    staticClass: "tc-box-model-center"
  }, [_vm._v(_vm._s(_vm.$t('all.quedingqudengluma')))]) : _vm._e(), _vm._v(" "), (_vm.data == 0) ? _c('div', {
    staticClass: "tc-box-model-bottom",
    on: {
      "click": _vm.login
    }
  }, [_vm._v(_vm._s(_vm.$t('all.queding')))]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-610b04e1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tuichudenglu/tuichudenglu.vue
// module id = 1032
// module chunks = 1